import React from 'react'

import singleBonusImage from '@assets/bonus-system/Single_Bonus_image.png'
import { DeclineTemplate } from '@components/BonusSystemCommon'
import { buildGradientStyle } from '@utils/buildGradientStyle'
import { DeclineBonusInfo, DeclineBonusStyles } from '@components/BonusSystemCommon/content/DeclineTemplate'
import { useTranslation } from '@amusnet/translations/react'
import { FreeSpinsBonus } from '@amusnet/mgs-ws-client'

interface FSDeclineProps {
    bonus?: FreeSpinsBonus
}

const FSDecline: React.FC<FSDeclineProps> = ({ bonus }) => {
    const { t } = useTranslation()

    const bundleType = bonus ? t('gameui.bonusSystem.freeSpin', undefined, Number(bonus.remainingAmount)) : ''

    const bonusInfo: DeclineBonusInfo | undefined = bonus && {
        betValue: bonus.betValue,
        bundleDetails: [
            { text: bonus.remainingAmount ?? '', styles: 'text-9xl font-black text-yellow-300 leading-tight' },
            { text: bundleType, styles: 'text-4xl font-black text-yellow-300 leading-snug' },
        ],
    }

    const styles: DeclineBonusStyles = {
        primaryTextColor: 'text-white',
        secondaryTextColor: 'text-yellow-300',
        background: buildGradientStyle(['#19191C 19.44%', '#793F06 100%'], '180deg'),
        image: singleBonusImage,
    }

    return <DeclineTemplate bonusInfo={bonusInfo} styles={styles} />
}

export default FSDecline
